import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { clientConstants, clientModels } from '..';

export const useClientCashback = (props: { clientId?: number } = {}) =>
  useQuery<clientModels.IClientCashback>({
    queryKey: [clientConstants.queryKeys.CLIENT_CASHBACK, props?.clientId],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/client/cashback',
          query: props
        })
      );

      return res.data.data;
    },
    enabled: !!props?.clientId
  });
